module.exports = __webpack_public_path__ + "img/loading.c88d94a4.gif";